<template>
  <div class="container py-5">
    <p>
    <b>TSK 邀您共赴2024臺灣整形外科醫學會年會！</b><br><br>針對精準醫療的每一刻，TSK始終以尖端工藝和高品質標準，為醫療專業人士提供安全、優質且令人安心的產品。<br><br><b>🌟 展會亮點搶先看 🌟<br> • 全系列尖針、鈍針型號現場展示<br> • 日本匠心製造，親臨攤位體驗TSK針頭的卓越手感<br> • 現場專屬優惠活動與驚喜好禮等您來參加</b><br><br><b>現場更多優惠與驚喜等您來發現，不要錯過⮕</b><br>展會時間：2024/12/7(六)-8(日)<br> 展會地點：南港展覽館2館7樓<br> 攤位編號：44
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_51.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
